import {NgModule} from '@angular/core';
import {NgxDaterangepickerMd} from 'ngx-daterangepicker-material';
import {PagesSharedModule} from '../../../pages/pages-shared.module';
import {DateInputComponent} from './date-input.component';
import {DateInputPopoverComponent} from './date-input-popover.component';

@NgModule({
    imports: [
        PagesSharedModule,
        NgxDaterangepickerMd.forRoot()
    ],
    declarations: [
        DateInputComponent,
        DateInputPopoverComponent,
    ],
    entryComponents: [
        DateInputPopoverComponent,
    ],
    exports: [
        DateInputComponent,
    ]
})
export class DateInputModule {
}

